import React, { useLayoutEffect, useRef, useState } from "react"
import { Col, Container, Row } from "reactstrap"
import styled from "styled-components"
import { gsap } from "gsap"
import vars from "styles/variables"
import useProjects from "hooks/useProjects"
import { useHistory } from "react-router-dom"
import Seo from "components/common/Seo"

function ProjectsPage() {
  const { projects } = useProjects()
  const projectsContainer = useRef()
  const q = gsap.utils.selector(projectsContainer)
  const [isProjectHover, setIsProjectHover] = useState(false)
  const history = useHistory()

  useLayoutEffect(() => {
    gsap
      .timeline()
      .to(q(".data-creativity-title-1"), {
        opacity: 1,
        x: 0,
        duration: 1.6,
      })
      .to(
        q(".data-creativity-title-2"),
        {
          opacity: 1,
          x: 0,
          duration: 1.6,
        },
        0.5
      )

    gsap.from(q(".project-item"), {
      opacity: 0,
      yPercent: 100,
      duration: 1,
      stagger: 0.2,
      ease: "back.out(1.7)",
    })
  }, [])

  return (
    <>
      <Seo title="Our Projects" />
      <StyledProjectContainer
        className={`${isProjectHover ? "active" : ""}`}
        ref={projectsContainer}
      >
        <Container>
          <Row className="justify-content-center mb-5">
            <Col xs="12">
              <StyledTitle>
                <span className="data-creativity-title-1">our</span>
                <span className="data-creativity-title-2">projects</span>
              </StyledTitle>
            </Col>
          </Row>

          <StyledProjectsGrid>
            {projects.map(item => (
              <StyledProjectScaleUp key={item.slug}>
                <StyledProjectItem
                  className="project-item"
                  bgImage={item.listImageOuter}
                  onMouseEnter={() => setIsProjectHover(true)}
                  onMouseLeave={() => setIsProjectHover(false)}
                  //onClick={() => history.push(`/projects/${item.slug}`)}
                >
                  <StyledProjectItemContent
                    bgImage={item.listImageInner}
                    className="project-content"
                  >
                    {item.title}
                  </StyledProjectItemContent>
                </StyledProjectItem>
              </StyledProjectScaleUp>
            ))}
          </StyledProjectsGrid>
        </Container>
      </StyledProjectContainer>
    </>
  )
}

export default ProjectsPage

const StyledProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(33.33%, 280px), 1fr));
  gap: 24px;

  @media (max-width: ${vars.screen_xs_max}) {
    gap: 12px;
  }
`

const StyledTitle = styled.h2`
  font-size: 56px;
  line-height: 1;
  font-weight: 600;
  letter-spacing: 5px;
  margin-bottom: 0;

  span {
    display: block;
  }

  .data-creativity-title-1 {
    margin-bottom: 5px;
    opacity: 0;
    transform: translate(-50px, 0px);
  }

  .data-creativity-title-2 {
    margin-left: 100px;
    opacity: 0;
    transform: translate(-50px, 0px);
  }

  @media (max-width: ${vars.screen_xs_max}) {
    font-size: 38px;
    margin-bottom: 0;
  }
`

const StyledProjectScaleUp = styled.div`
  transition: ease-in-out 500ms;
  width: 100%;
  margin: 0 auto;

  &:hover {
    transform: scale(1.1) !important;
  }
`

const StyledProjectContainer = styled.div`
  padding-top: 100px;

  &.active:hover {
    .project-scale-up {
      transform: scale(0.95);
    }
  }
`

const StyledProjectItem = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: relative;
  background: url(${props => props.bgImage}) no-repeat center center;
  background-size: cover;

  &:hover {
    .project-content {
      clip-path: circle(50%);
    }
  }
`

const StyledProjectItemContent = styled.div`
  width: 100%;
  height: 100%;
  background: url(${props => props.bgImage}) no-repeat center center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  clip-path: circle(35%);
  z-index: 10;
  color: ${vars.white};
  font-size: 24px;
  padding: 20%;
  text-align: center;
  background-size: cover;
  transition: ease-in-out 500ms;
  text-shadow: 2px 4px 16px rgba(0, 0, 0, 1), 2px 4px 8px rgba(0, 0, 0, 1);

  @media (max-width: ${vars.screen_xs_max}) {
    font-size: 18px;
  }
`
